export default __webpack_public_path__ + "static/home-main-xs-6d63c1538205b621b276c754f902078b.jpg";